import MODS      from './Modules/Modules.js'
import resources from './Modules/resources.js'

import * as THREE from 'three'

let instance = null

export default class Experience {
    constructor(canvas)
    {
        // Singleton
        if(instance)
        {
            return instance
        }

        // Initial Setup
        instance = this

        // Parameters
        this.canvas = canvas

        // Setup Utils
        this.time  = new MODS.Time()
        this.sizes = new MODS.Sizes(this.canvas)
        this.debug = new MODS.Debug()
        this.input = new MODS.Input()
        this.loader = new MODS.Loader(resources)

        // Setup Experience
        this.scene  = new THREE.Scene()
        this.camera = new MODS.Camera()
        this.renderer = new MODS.Renderer()

        // Setup World
        this.world = new MODS.World()

        // Events
        this.sizes.on('resize', () => this.resize())
        this.time.on('visible', () => this.resize())
        this.time.on('tick', () => this.update())
    }

    // Callback Functions
    
    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.world.update()
        this.camera.update()
        this.renderer.update()
    }

    // Destroy All
    destroy() {
        // Delete Events
        this.sizes.off('resize')
        this.time.off('tick')

        // Delete Objects
        this.scene.traverse((child)=> {
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()

                for(const key in child.material)
                {
                    const value = child.material[key]

                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })

        // Delete Renderer
        this.renderer.instance.dispose()

        // Delete Debugger
        if(this.debug.active)
        {
            this.debug.ui.destroy()
        }
    }
}